import { createAuthClient } from "better-auth/react";

// Empty string means use current origin (for proxied setup), undefined means use localhost
const baseURL = import.meta.env.VITE_BETTER_AUTH_URL !== undefined
  ? import.meta.env.VITE_BETTER_AUTH_URL
  : import.meta.env.VITE_API_URL !== undefined
  ? import.meta.env.VITE_API_URL
  : "http://localhost:3000";

// Debug: Log the auth base URL on initialization (only in development)
if (import.meta.env.DEV) {
  console.log("[Auth Config] VITE_BETTER_AUTH_URL:", import.meta.env.VITE_BETTER_AUTH_URL);
  console.log("[Auth Config] VITE_API_URL:", import.meta.env.VITE_API_URL);
  console.log("[Auth Config] baseURL:", baseURL);
}

export const authClient = createAuthClient({
  baseURL,
});

export const { useSession } = authClient;
